import { ttsVoicesByLanguage } from '@xsc/shared';

interface Props {
  id?: string;
  value: string;
  onChange: (v: string) => void;
  className?: string;
  includeEmpty?: boolean;
  emptyLabel?: string;
}

/**
 * Grouped <select> of the PBX's supported TTS voices.
 * Renders <optgroup> per language for usability with ~95 voices.
 */
export function TtsVoiceSelect({
  id,
  value,
  onChange,
  className,
  includeEmpty = false,
  emptyLabel = '— Use default —',
}: Props) {
  const groups = ttsVoicesByLanguage();
  return (
    <select
      id={id}
      className={className}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      {includeEmpty && <option value="">{emptyLabel}</option>}
      {groups.map((g) => (
        <optgroup key={g.language} label={g.language}>
          {g.voices.map((v) => (
            <option key={v.value} value={v.value}>
              {v.label}
            </option>
          ))}
        </optgroup>
      ))}
    </select>
  );
}
